const resources = {
    freeReturns: 'Free returns',
    exclusions: 'see details/exclusions.*',
    allPurchases: 'on all purchases.*'
};

module.exports = function getResource(label) {
    return resources[label];
};
